import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private client: any;
  private db: IDBDatabase | undefined;

  constructor(private http: HttpClient) {}

  loadClientData(): Observable<any> {
    return from(
      this.http.get(`${environment.txBaseUrl}/api/fetchAppConfig`)
    ).pipe(
      switchMap((res: any) => {
        this.client = res;
        return from(this.createIndexDb());
      }),
      catchError(
        (error: any) =>
          new Observable<any>((observer) => {
            observer.error(error);
          })
      )
    );
  }

  createIndexDb(): Promise<any> {
    return new Promise((resolve, reject) => {
      const openIndexDB = indexedDB.open('clientData', this.client?.timestamp);
      openIndexDB.onupgradeneeded = (event: any) => {
        this.db = event.target.result;
        if (!this.db.objectStoreNames.contains('clientData')) {
          const storeOS = this.db.createObjectStore('clientData', {
            keyPath: 'name',
          });
        }
      };

      openIndexDB.onsuccess = async (event: any) => {
        this.db = event.target.result;
        const updatedIndexDbData = await this.updateDataInIndexDb();
        resolve(updatedIndexDbData);
      };

      openIndexDB.onerror = async (event: any) => {
        if (event.target.error.name === 'VersionError') {
          const response = await this.deleteIndexDb();
          reject(response);
        }
        reject(`Failed to initialize IndexedDB:'${event.target.error}`);
      };
    });
  }

  updateDataInIndexDb() {
    return new Promise((resolve, reject) => {
      const tx = this.db?.transaction('clientData', 'readwrite');
      if (!tx) {
        throw new Error('Transaction not available');
      }

      const store = tx.objectStore('clientData');
      const request = store.put({ ...this.client?.data, name: 'clientData' });

      request.onsuccess = async () => {
        try {
          const res = await this.readDataFromIndexDb();
          resolve(res);
        } catch (err) {
          reject(err);
        }
      };

      request.onerror = (event: any) => {
        reject(`Error updating data:- ${event.target.error}`);
      };
    });
  }

  readDataFromIndexDb() {
    return new Promise((resolve, reject) => {
      const tx = this.db.transaction('clientData', 'readonly');
      if (!tx) {
        throw new Error('Transaction not available');
      }
      const store = tx.objectStore('clientData');
      const request = store.get('clientData');
      request.onsuccess = (event: any) => {
        resolve(event.target.result);
      };

      request.onerror = (event: any) => {
        reject(`Error reading data from IndexedDB: ${event.target.error}`);
      };
    });
  }

  deleteIndexDb() {
    return new Promise((resolve, reject) => {
      const closeIndexDb = indexedDB.deleteDatabase('clientData');
      closeIndexDb.onsuccess = (event: any) => {
        resolve('Database deleted successfully');
        window.location.reload();
      };
      closeIndexDb.onerror = (event: any) => {
        reject(`Error deleting database: ${event.target.error}`);
      };
    });
  }
}
